/**
 * ehr#437 reopen (PROGRESS_NOTE_10-14-V81 rail): the note page's rail cards fold to their header.
 * ehr#571 (PROGRESS_NOTE_10-20-V141 V111, V115): every card starts open; its arrow, or Collapse all
 * above the rail, folds it for this note only (nothing is remembered for the next note).
 */
export type RailCard = 'quick' | 'changes' | 'measures' | 'last';
export interface RailFold {
  open: boolean;
  onToggle: () => void;
}

/** The chevron on a rail card's header. */
export function RailFoldBtn({ fold, title }: { fold: RailFold; title: string }) {
  return (
    <button
      type="button"
      className={`pn-fold pn-rail-fold${fold.open ? '' : ' shut'}`}
      aria-expanded={fold.open}
      aria-label={`${fold.open ? 'Fold' : 'Show'} ${title}`}
      onClick={fold.onToggle}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>
  );
}
